/**
 * @Description 全局导出组件
 * @author 滕威
 * @time 2019-12-02
 */
import select from "./common/select";
import list from "./common/list";
import editor from "./common/editor";
import collapseForm from "./common/collapseForm";
import form from "./common/form";
import cascader from "./common/cascader";
import tooltip from "./common/tooltip";
import calock from "./common/calock";
import table from "./common/table";
import dialogSetInterval from "./common/dialogSetInterval";
import auditHis from "./common/auditHis";
import caDetection from "./common/caDetection";

function plugin(Vue) {
  if (plugin.installed) return;
  Vue.component("Co-select", select);
  Vue.component("Co-list", list);
  Vue.component("Co-editor", editor);
  Vue.component("Co-collapseForm", collapseForm);
  Vue.component("Co-form", form);
  Vue.component("Co-cascader", cascader);
  Vue.component("Co-tooltip", tooltip);
  Vue.component("Co-calock", calock);
  Vue.component("Co-table", table);
  Vue.component("Co-dialogSetInterval", dialogSetInterval);
  Vue.component("Co-auditHis", auditHis);
  Vue.component("Co-caDetection", caDetection);
}

export default plugin;
